<template>
  <section class="page-container">
    <slot></slot>  
  </section>
</template>
<script>
export default {
  name: "page-container",
};
</script>
<style lang="less" scope>
  @pageWidth: 1120px;
  @pageHeight: 794px;

  .page-container {
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: @pageWidth;
    height: @pageHeight;
    margin: 0 auto;
    box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.3);
    background-color: @pure-white;
  }
</style>